<template>
  <div id="v2-course-list-tab">
    <div class="tab-wrapper">
      <div
        v-for="item in courseTypes"
        :key="item.id"
        class="tab-item"
        :class="{ selected: item.id == selected.id }"
        @click="selected = item"
      >{{ item.name }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "V2CourseListTab",
  props: ["courseTypes", "defaultType"],
  data() {
    return {
      selected: null,
    }
  },
  watch: {
    selected: function (val) {
      this.$emit("selected", val)
    },
  },
  created() {
    this.selected = this.defaultType ? this.defaultType : this.courseTypes[0]
  },
}
</script>
<style scoped lang="scss">
#v2-course-list-tab {
  position: fixed;
  top: 0;
  left: 0;
  padding: 13px 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  width: 100%;
  z-index: 100;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  overflow-x: auto;
  overflow-y: hidden;
  background: white;

  .tab-wrapper {
    animation-delay: 0s !important;
    animation-duration: 0.5s !important;
  }
  .tab-item {
    display: inline-block;
    margin: 0 10px 0 0;
    font-weight: 500;
    opacity: 0.5;
    transition: 0.1s;
    font-size: 13px;
  }
  .tab-item:first-child {
    margin-left: 5%;
  }
  .tab-item:last-child {
    margin-right: 15px;
  }
  .selected {
    color: $red;
    opacity: 1;
  }
}
</style>
